import { Box, IconButton, Modal } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { DpFanQuickCard, type DpFanQuickCardProps } from '@/components/blocks/DpFanQuickCard';
import {
	closeButtonSX,
	dialogContainerSX,
	modalRootSX,
	modalSX,
} from '@/components/blocks/DpFanQuickAdaptiveDialog/styles';
import { useDismissibleDialog } from '@/utils/dismissibleDialog';
import { useLockBodyScroll } from '@/utils/useLockBodyScroll';

export const DpFanQuickAdaptiveDialog: React.FC<DpFanQuickCardProps> = (props) => {
	const { open, close } = useDismissibleDialog({
		storageKey: 'DpFanQuickAdaptiveDialog',
		hiddenSeconds: 86400,
	});

	useLockBodyScroll(open);

	return (
		<Modal
			slotProps={{
				root: {
					sx: modalRootSX,
				} as any,
			}}
			sx={modalSX}
			open={open}
			onClose={close}
		>
			<Box sx={dialogContainerSX}>
				<IconButton color="inherit" onClick={() => close()} sx={closeButtonSX}>
					<ClearIcon color="inherit" fontSize="inherit" />
				</IconButton>

				<DpFanQuickCard {...props} onClick={close} />
			</Box>
		</Modal>
	);
};
